module.exports = __webpack_public_path__ + "media/components/Sponsors/Layouts/SideMenu/logo-8f9ed38f3f5840e8abc0bfe8c8f3eaf9.png";